const API_CONFIG = {
  apiURL: process.env.REACT_APP_ZDASH_URL,
  apiRedirectURL: process.env.REACT_APP_REDIRECT_URL || window.location.origin,
  isSmallBusinessSign: process.env.REACT_APP_SIGN_UP_TYPE === 'SMALL_BUSINESS',
  publishableKey: process.env.REACT_APP_STRIPE_API_KEY,
};

export default API_CONFIG;

export const PRO_QSR_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'pro_qsr_join_now' : 'pro_qsr';
export const ESSENTIALS_FOOD_TRUCK_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'essentials_food_truck_join_now' : 'essentials_food_truck';
export const ESSENTIALS_QSR_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'essentials_qsr_join_now' : 'essentials_qsr';
export const PRO_FOOD_TRUCK_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'pro_food_truck_join_now' : 'pro_food_truck';


export const DIGITAL_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'digital_join_now' : 'digital';
export const STARTER_CONFIG = {
    key: 'starter',
    displayName: 'Starter',
};
export const PRO_CONFIG = {
    key: 'pro',
    displayName: 'Pro',
};
export const ESSENTIAL_CONFIG = {
    key: 'essential',
    displayName: 'Essential',
};
export const ELITE_CONFIG = {
    key: 'elite',
    displayName: 'Elite',
};

// CS = Complete Suites
export const CSPlanIncludedFeatures = {
  [STARTER_CONFIG.key]: {
    features: [
      { title: 'Kitchen management & restaurant dashboard software.' },
      { title: 'Online, order ahead & QR code.' },
      { title: 'Consumer profiles.' },
      { title: 'Intelligent upselling & smart tipping.' },
      { title: 'Revi rewards program & gift cards.' },
      { title: '0% commission deliveries (drivers Included).' },
      { title: 'Self-Serve Kiosk (clamp or standing).' },
      { title: 'Kitchen Display Screen (printer included).' },
      { title: 'Mobile/handheld POS.' },
      { title: 'Revi Support.' },
    ],
    includedFeaturesOf: []
  },
  [ESSENTIAL_CONFIG.key]: {
    features: [{ title: 'Catering & events.' }],
    includedFeaturesOf: [STARTER_CONFIG.key]
  },
  [PRO_CONFIG.key]: {
    features: [
      { title: 'POS (cashbox & printer included).' },
      { title: 'Dedicated Account Manager.' },
      { title: 'Advanced marketing & materials.' },
      { title: 'Free hardware shipping (for initial setup only).' },
    ],
    includedFeaturesOf: [STARTER_CONFIG.key, ESSENTIAL_CONFIG.key]
  },
  [ELITE_CONFIG.key]: {
    features: [
      { 
        title: 'In-person hardware installation*.',
        // Removed disclaimer because it was not clear and was causing confusion.
        // disclaimer: '*No early termination messes up the 1 & 3 year for elite. They can get 3 year elite and cancel after 1 year with no penalty.'
      },
      { title: 'Expedited implementation.' },
      { title: 'Free hardware replacement.' },
      { title: 'No early termination fee*.', disclaimer: ' ' },
    ],
    includedFeaturesOf: [STARTER_CONFIG.key, ESSENTIAL_CONFIG.key, PRO_CONFIG.key]
  }
};

export const CSPlanIncludedFeaturesDisclaimers = Object.keys(CSPlanIncludedFeatures).reduce((acc, curr) => {
  const features = CSPlanIncludedFeatures[curr].features;
  const disclaimers = features.filter((feature) => feature.disclaimer);
  if (!disclaimers?.length) return acc;
  acc[curr] = disclaimers.map((feature) => feature.disclaimer);
  return acc;
}, {});
